import { useParams } from 'react-router';
import { useApiRead } from 'api-read-hook';
import { Api } from '../../api';
import { ScreenError, SoloLoading } from '../../components';
import ChatDetailLoaded from './ChatDetailLoaded';
import { Model } from '../../models';
import type { HydraCollection } from '../../types';

export default function ChatArchiveDetail() {
  const { userId } = useParams();

  const archivedApi = Api.ChatConversation.useReadCollectionClinicianarchived({
    staleWhileInvalidated: true,
  });

  const userChat = Model.Chat.findChatByUserId(
    archivedApi.data?.member,
    userId,
  );

  const conversationId = userChat?.conversation?.id;

  const messagesApi = useApiRead<
    HydraCollection<Api.ChatMessage.V_ChatConversationSub>
  >(conversationId ? `/chat-conversations/${conversationId}/messages` : null, {
    staleWhileInvalidated: true,
  });

  if (archivedApi.error) return <ScreenError {...archivedApi} />;
  if (messagesApi.error) return <ScreenError {...messagesApi} />;

  if (!archivedApi.data || (conversationId && !messagesApi.data)) {
    return <SoloLoading />;
  }

  const user = userChat?.user || null;

  return (
    <ChatDetailLoaded
      messagesApi={messagesApi}
      chatsApi={archivedApi}
      user={user}
      team={null}
      chatType="archived"
      userId={userId}
      teamId={undefined}
      entityType={undefined}
    />
  );
}
